import { useAuth } from "context/AuthContext";
import Layout from "layout/Layout";
import LoggedInLayout from "layout/LoggedInLayout";
import "leaflet/dist/leaflet.css";
import ErrorPage from "pages/error.pages/ErrorPage";
import "primeicons/primeicons.css";
import { PrimeReactProvider } from "primereact/api";
import "primereact/resources/themes/bootstrap4-light-purple/theme.css";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import routes from "routes";
import { noLayoutRoutes } from "routes/noLayoutRoutes";
import "./App.css";
import "/node_modules/primeflex/primeflex.css";

const App = () => {
  const { accessToken } = useAuth();

  const router = createBrowserRouter(
    [
      {
        path: "/",
        element: accessToken ? <LoggedInLayout /> : <Layout />,
        errorElement: <ErrorPage />,
        children: routes,
      },
      ...noLayoutRoutes,
    ],
    {
      basename: "/",
    }
  );

  return (
    <PrimeReactProvider>
      <RouterProvider router={router} />
    </PrimeReactProvider>
  );
};

export default App;
